import { Helmet } from "react-helmet";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute"; // This is where the magic happens!
import SignIn from "./container/Auth/SingIn";

import AdminDashboard from "./container/Auth/Dashboard";
import User from "./container/HomePage/users";
import BlogList from "./container/HomePage/blogs";
import Providers from "./container/HomePage/providers";
import AddBlogs from "./container/HomePage/Pages/addBlogs";
import EditBlogs from "./container/HomePage/Pages/editBlog"; // Exported as EditBlog but imported as EditBlogs
import Edit from "./container/HomePage/Pages/edit";
import UserDetails from "./container/HomePage/Pages/userDetails";
import AddUserDetails from "./container/HomePage/Pages/addUserdetails";
import ChallengeDetails from "./container/HomePage/Pages/challengeDetails";
import ProviderDetails from "./container/HomePage/Pages/providerDetails";
import EditProvider from "./container/HomePage/Pages/editProvider";
import AddProvider from "./container/HomePage/Pages/addProvider";
import Transactions from "./container/HomePage/Pages/transactions";
import ClaimRequests from "./container/HomePage/Pages/ClaimRequests";
import ProviderProducts from "./container/HomePage/Pages/ProviderProducts";
import Settings from "./container/HomePage/Pages/Settings";
import ContactInquiries from "./container/HomePage/Pages/ContactInquiries";
import { Navigate } from "react-router-dom"; // ADD THIS

// Inside your routes

import "bootstrap/dist/js/bootstrap.bundle.min.js";

function DynamicTitle() {
  const location = useLocation();

  const getTitle = () => {
    switch (location.pathname) {
      case "/admin/dashboard":
        return "Admin | Dashboard";
      case "/admin/challenge":
        return "Admin | Challenge";
      case "/admin/sales-report":
        return "Admin | Sales Report";
      case "/admin/settings":
        return "Admin | Settings";
      case "/admin/contact-inquiries":
        return "Admin | Contact Inquiries";
      default:
        return "Admin | Login";
    }
  };

  return (
    <Helmet>
      <title>{getTitle()}</title>
    </Helmet>
  );
}

function App() {
  return (
    <Router>
      <DynamicTitle />
      <Routes>
        {/* Default SignIn Route */}
        {/* <Route path="/admin/login" element={<SignIn />} /> */}
        <Route path="/" element={<Navigate to="/admin/login" replace />} />

        <Route path="/admin/login" element={<SignIn />} />

        {/* Protected Admin Routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/admin/dashboard" element={<AdminDashboard />} />

          {/* Users Routes */}
          <Route path="/admin/user" element={<User />} />
          <Route path="/admin/user/edit/:id" element={<Edit />} />
          <Route path="/admin/user/:id" element={<UserDetails />} />
          <Route path="/admin/user/add" element={<AddUserDetails />} />

          {/* Blog Routes */}
          <Route path="/admin/bloglist" element={<BlogList />} />
          <Route path="/admin/bloglist/edit/:id" element={<EditBlogs />} />
          <Route path="/admin/bloglist/add" element={<AddBlogs />} />

          {/* Provider Routes */}
          <Route path="/admin/providers" element={<Providers />} />
          <Route path="/admin/providers/add" element={<AddProvider />} />
          <Route path="/admin/providers/:id" element={<ProviderDetails />} />
          <Route path="/admin/providers/edit/:id" element={<EditProvider />} />

          {/* Claim Requests Route */}
          <Route path="/admin/claims" element={<ClaimRequests />} />

          {/* Transactions Route */}
          <Route path="/admin/transactions" element={<Transactions />} />

          <Route path="/admin/settings" element={<Settings />} />
          <Route path="/admin/contact-inquiries" element={<ContactInquiries />} />

          {/* Other Routes - Commented out as files don't exist yet */}
          <Route path="/admin/challenge/:id" element={<ChallengeDetails />} />

          <Route
            path="/admin/providers/products/:id"
            element={<ProviderProducts />}
          />
          <Route
            path="/admin/providers/products/:id/new"
            element={<ProviderProducts />}
          />
          <Route
            path="/admin/providers/products/:id/fetch"
            element={<ProviderProducts />}
          />
          <Route
            path="/admin/providers/products/:id/import"
            element={<ProviderProducts />}
          />
          <Route
            path="/admin/providers/products/:id/edit/:productId"
            element={<ProviderProducts />}
          />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
